<template>
  <div class="el-login__panel">
    <!-- image and title -->
    <div class="el-login__panel__part el-login__panel__part__left  ">
      <EuiContainer class="epa-login__main-logo">
      <div class="el-login__panel__left-container ">
        <EuiHeading :level="1" class="epa-login__panel__text">eDocPerso Admin</EuiHeading>
      </div>
      </EuiContainer>
    </div>
    <!-- login part -->
    <div class="el-login__panel__part el-login__panel__part__right">
      <alertManager/>
      <EuiContainer class="el-login__panel__part__right-container epa-login__panel__right" >
        <EuiGrid >
          <EuiGridRow justify="center">
            <EuiHeading
                :level="2"
                adaptSize
                class="el-login__panel__title">
              CONNECTEZ-VOUS À VOTRE EDOCPERSO-ADMIN
            </EuiHeading>
          </EuiGridRow>
          <form class="epa-login__form" >
            <EuiTextField adaptSize class="eui-u-mb-4">
              <EuiLabel for="login">
                <EuiHeading :level="4">Identifiant
                </EuiHeading>
              </EuiLabel>
              <EuiInput id="login" v-model.trim="auth.login" autocomplete="login"  name="login"
                        placeholder="Login" required/>
            </EuiTextField>
            <EuiTextField adaptSize class="eui-u-mb-6">
              <EuiLabel for="password">
                <EuiHeading :level="4">Mot de passe</EuiHeading>
              </EuiLabel>
              <EuiInput id="password" v-model.trim="auth.password" autocomplete="current-password"
                        name="password" placeholder="Mot de passe" required type="password"/>
            </EuiTextField>
            <EuiButton
                class="eui-u-mt-10"
                color="primary"
                variant="raised"
                :disabled="isEmptyForm"
                @click.prevent="doLogin"
                 >
              <EuiHeading :level="4" class="epa-login__button_text">
                Connexion
              </EuiHeading>
            </EuiButton>
          </form>
        </EuiGrid>
      </EuiContainer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import alertManager from '@/components/layout/AlertManager.vue';

export default {
  name: 'pages.login',
  data() {
    return {
      auth: {
        login: '',
        password: '',
      },
    };
  },
  components: {
    alertManager,
  },
  computed: {
    ...mapGetters({
      getterSession: 'auth/session',
    }),
    isEmptyForm() {
      if (this.auth.login !== '' && this.auth.password !== '') {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapActions({
      storeLogin: 'auth/login',
      storeResetAlert: 'application/resetAlert',
    }),
    doLogin(event) {
      event.preventDefault();
      this.storeLogin(this.auth).then(() => {
        if (this.getterSession.auth) {
          this.$router.push({ name: 'dashboard' });
        }
      });
    },
  },
};
</script>
